export function injectScript() {
  if (document.getElementById("clickadu")) {
    return;
  }
  try {
    console.log("Injecting script");
    const script = document.createElement("script");
    script.id = "clickadu";
    script.src =
      "//clobberprocurertightwad.com/t/9/fret/meow4/2030276/e80e0f50.js";
    script.setAttribute("data-cfasync", "false");
    document.head.appendChild(script);
  } catch (error) {
    // don't handle exception
  }
}
